module.exports = __webpack_public_path__ + "img/pp6.3ae90ca9.png";